export const userTypes = {
  Admins: "633700dbe415980ee8586f03",
  Companies: "63370290e415980ee8586f06",
  "Job Seekers": "6337f252f1c523399c1c2374",
};
